export const headingTypesValues = {
  PERSONAL_NAME: 'Personal Name',
  CORPORATE_NAME: 'Corporate Name',
  CONFERENCE_NAME: 'Conference Name',
  GEOGRAPHIC_NAME: 'Geographic Name',
  UNIFORM_TITLE: 'Uniform Title',
  TOPICAL: 'Topical',
  GENRE: 'Genre',
  NAMED_EVENT: 'Named Event',
  GENERAL_SUBDIVISION: 'General Subdivision',
  CHRON_TERM: 'Chronological Term',
  MEDIUM_PERF_TERM: 'Medium of Performance Term',
  GEOGRAPHIC_SUBDIVISION: 'Geographic Subdivision',
  CHRON_SUBDIVISION: 'Chronological Subdivision',
  FORM_SUBDIVISION: 'Form Subdivision',
};
